import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-education-reporting-dashboard',
  templateUrl: './education-reporting-dashboard.component.html',
  styleUrls: ['./education-reporting-dashboard.component.scss']
})
export class EducationReportingDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
